import { fetchRollingReserves } from "./actions/fetchRollingReserves";

export const actions = {
    fetchRollingReserves: fetchRollingReserves,
};
